import React, { useEffect, useRef, useState } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { CataloguePage } from "pages/CataloguePage/CataloguePage";
import { CartPage } from "pages/CartPage/CartPage";
import { CatalogueItemPage } from "pages/CatalogueItemPage/CatalogueItemPage";
import { Page404 } from "pages/404/Page404";
import { Header } from "components/Header/Header";
import { cartItems, itemControllerInfo } from "assets/types";
import { BreadCrumbs } from "components/BreadCrumbs/BreadCrumbs";
import { Footer } from "components/Footer/Footer";
import { ItemController } from "components/ItemController/ItemController";
import { useDispatch } from "react-redux";
import { setMobile } from "store/slices/mobile";
import { setWindowSize } from "store/slices/windowSize";

export const AppRouter = () => {
  const dispatch = useDispatch();

  const [cartItems, setCartItems] = useState<cartItems>(
    JSON.parse(localStorage.getItem("cartItems") || "[]")
  );
  const [itemControllerInfo, setItemControllerInfo] =
    useState<itemControllerInfo>({ active: false });

  const firstRender = useRef(true);
  const resizeHandler = () => {
    if (window.innerWidth < 680) {
      dispatch(setMobile(true));
    } else {
      dispatch(setMobile(false));
    }

    dispatch(
      setWindowSize({ width: window.innerWidth, height: window.innerHeight })
    );
  };

  useEffect(() => {
    if (firstRender.current === true) {
      firstRender.current = false;

      resizeHandler();

      window.addEventListener("resize", resizeHandler);

      document.addEventListener("keydown", (e) => {
        e.key === "Escape" &&
          setItemControllerInfo({ data: undefined, active: false });
      });
    }
  });

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const cataloguePage = (
    <CataloguePage
      cartItems={cartItems}
      getCartItems={(result: cartItems) => {
        setCartItems(result);
      }}
      getItemControllerInfo={(result: itemControllerInfo) => {
        setItemControllerInfo(result);
      }}
    />
  );

  return (
    <HashRouter>
      <Header cartItems={cartItems} />
      <BreadCrumbs />
      <Routes>
        <Route element={<Page404 />} path="*" />
        <Route element={cataloguePage} path="/" />
        <Route element={cataloguePage} path="/catalogue" />
        <Route
          element={
            <CartPage
              cartItems={cartItems}
              getCartItems={(result) => setCartItems(result)}
            />
          }
          path="/cart"
        />
        <Route
          element={
            <CatalogueItemPage
              cartItems={cartItems}
              getCartItems={(result) => {
                setCartItems(result);
              }}
            />
          }
          path="/catalogue/:id"
        />
      </Routes>
      <Footer />
      {itemControllerInfo.active && (
        <ItemController
          itemInfo={itemControllerInfo.data}
          closeCallback={() => {
            setItemControllerInfo({ data: undefined, active: false });
          }}
        />
      )}
    </HashRouter>
  );
};
